var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54519 8.84554V10.2064C4.44218 10.2064 3.38435 10.6365 2.60441 11.4021C1.82446 12.1678 1.3863 13.2062 1.3863 14.289H0C0 12.8453 0.584224 11.4607 1.62415 10.4399C2.66407 9.41904 4.07451 8.84554 5.54519 8.84554ZM5.54519 8.16512C3.2474 8.16512 1.3863 6.33817 1.3863 4.08256C1.3863 1.82694 3.2474 0 5.54519 0C7.84298 0 9.70408 1.82694 9.70408 4.08256C9.70408 6.33817 7.84298 8.16512 5.54519 8.16512ZM5.54519 6.80426C7.07705 6.80426 8.31778 5.5863 8.31778 4.08256C8.31778 2.57882 7.07705 1.36085 5.54519 1.36085C4.01333 1.36085 2.77259 2.57882 2.77259 4.08256C2.77259 5.5863 4.01333 6.80426 5.54519 6.80426ZM9.70408 13.9487L7.66692 15L8.05577 12.7736L6.40816 11.1964L8.68584 10.8712L9.70408 8.84554L10.723 10.8712L13 11.1964L11.3524 12.7736L11.7406 15L9.70408 13.9487Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminManagerIcon);
export default __webpack_public_path__ + "static/media/AdminManagerIcon.3f8aeebb3817d39f68a8796af6af5a23.svg";
export { ForwardRef as ReactComponent };